export const RECOM_GUEST_SESSION_KEY = 'recomGuestSessionId';

const canUseStorage = () => typeof window !== 'undefined' && Boolean(window.localStorage);

const uuid = () => {
	if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
		return crypto.randomUUID();
	}

	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
		const random = (Math.random() * 16) | 0;
		return (char === 'x' ? random : (random & 0x3) | 0x8).toString(16);
	});
};

export const readRecomGuestSessionId = (): string | null => {
	if (!canUseStorage()) return null;
	try {
		return localStorage.getItem(RECOM_GUEST_SESSION_KEY);
	} catch {
		return null;
	}
};

export const ensureRecomGuestSessionId = (): string | null => {
	const stored = readRecomGuestSessionId();
	if (stored) return stored;
	if (!canUseStorage()) return null;

	const sessionId = uuid();
	try {
		localStorage.setItem(RECOM_GUEST_SESSION_KEY, sessionId);
		return sessionId;
	} catch {
		return null;
	}
};

export const removeRecomGuestSessionId = (): void => {
	if (!canUseStorage()) return;
	try {
		localStorage.removeItem(RECOM_GUEST_SESSION_KEY);
	} catch {}
};
